import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAutoScroll } from '../../hooks/useAutoScroll';

const getRenderTabs = (selected, cb, t) => tab => (
    <div
        key={tab.name}
        className={`tabItem ${selected === tab.name ? 'selected' : ''}`}
        onClick={() => {
            if (cb) cb(tab.name);
            if (tab.callback) tab.callback();
        }}
    >
        {t(tab.name)}
        {tab.icon ? <i className={`fa fa-${tab.icon}`} /> : false}
    </div>
);

const RealTabSwitcher = ({ tabs, onChange, selected }) => {
    const ref = useRef();
    const { t } = useTranslation();
    const { focusItem } = useAutoScroll(ref, 'tabItem');
    const renderTab = useMemo(() => getRenderTabs(selected, onChange, t), [selected, onChange]);

    useEffect(() => {
        focusItem();
    }, [tabs]);

    

    return (
        <React.Fragment>
            <div ref={ref} className={`tabSwitcherHeader`}>
                {tabs.map(renderTab)}
            </div>
        </React.Fragment>
    );
}

export default RealTabSwitcher;